<script setup>
import PlusRoundedIcon from "@/components/icons/PlusRoundedIcon.vue";
import MinusRoundedIcon from "@/components/icons/MinusRoundedIcon.vue";

defineProps({
  urlList: {
    type: Array,
    required: true,
    default: () => []
  }
});

const emit = defineEmits(["add-url", "delete-url"]);

const addUrl = () => {
  emit("add-url", {start_url: "", feed_url: ""});
};

const deleteUrl = (index) => {
  emit("delete-url", index);
};

</script>

<template>
  <div class="input-url">
    <div class="input-url__header">
      <div class="required-label input-url__header-title">
        Start URL
      </div>
      <div class="input-url__header-title">
        Feed URL
        <PlusRoundedIcon
          class="input-url__header-icon"
          aria-hidden="true"
          @click="addUrl"
        />
      </div>
    </div>
    <div
      v-for="(urlItem, index) in urlList"
      :key="urlItem"
      class="input-url__body"
    >
      <input
        v-model="urlItem.start_url"
        class="input-url__body-input"
        placeholder="Start URL"
        type="text"
      >
      <input
        v-model="urlItem.feed_url"
        placeholder="Feed URL"
        type="text"
        class="input-url__body-input"
      >
      <div
        v-if="urlList.length > 1"
        class="input-url__body-icon"
        @click="deleteUrl(index)"
      >
        <MinusRoundedIcon />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use '@/assets/styles/vars.scss';

.input-url {
  padding: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background: #F7F8FD;
  border-radius: 8px;

  &__header {
    display: grid;
    grid-template-columns: 30% 3fr;
    grid-gap: 2px;

    &-icon {
      color: #7B87A5;
      cursor: pointer;
      user-select: none;

      &:hover {
        color: #1F9AFF;
      }
    }
  }

  &__body {
    display: grid;
    grid-template-columns: 30% 3fr;
    grid-gap: 2px;
    position: relative;

    &:hover .input-url__body-icon {
      opacity: 1;
    }

    &-icon {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      width: 30px;
      height: 30px;
      cursor: pointer;
      user-select: none;
      color: #7B87A5;
      right: 1%;
      top: 50%;
      transform: translateY(-50%);
      opacity: 0;
      transition: 0.2s ease-in-out opacity;

      &:hover {
        color: #DA1E28;
      }
    }

    &-input {
      padding: 16px 24px;
      color: #212327;
      font-size: 16px;
      font-weight: 400;
      height: 60px;

      &:first-child {
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
      }

      &:last-child {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      }
    }
  }

  &__header-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: 500;
    font-size: 14px;
    color: #7B87A5;
  }
}
</style>
